import { z } from 'zod'

export const PlaceStatusSchema = z.enum(['active', 'inactive', 'suspended', 'delinquent'])

export const PlaceStatus = PlaceStatusSchema.enum

export type PlaceStatus = z.infer<typeof PlaceStatusSchema>

export const PlaceStatusFilterSchema = z.enum(['all', ...PlaceStatusSchema.options])

export const PlaceStatusFilter = PlaceStatusFilterSchema.enum

export type PlaceStatusFilter = z.infer<typeof PlaceStatusFilterSchema>

// Note: most severe first - the status badge and the status sort follow this order
export const PLACE_STATUS_SEVERITY: Record<PlaceStatus, number> = {
  active: 0,
  delinquent: 2,
  inactive: 1,
  suspended: 3,
}
